import { gql } from 'apollo-boost';

export const locationsByOrgIdQuery = gql`
  query location($orgId: ID!) {
    location {
      all(orgId: $orgId) {
        name
        id
        orgId
        primaryContactId
        externalId
        openFromTimeLocal
        openToTimeLocal
        address {
          address1
          address2
          city
          state
          country
          postalCode
        }
        timeZoneId
        pickupNotes
        deliveryNotes
        rowVersion
      }
    }
  }
`;

export const allLocationsQuery = gql`
  query location {
    location {
      all {
        name
        id
        orgId
        externalId
        address {
          address1
          address2
          city
          state
          country
          postalCode
        }
        pickupNotes
        deliveryNotes
        rowVersion
        timeZoneId
        primaryContactId
      }
    }
  }
`;

export const byId = gql`
  query location($id: ID!) {
    location {
      byId(id: $id) {
        id
        active
        externalId
        openFromTimeLocal
        openToTimeLocal
        name
        pickupNotes
        deliveryNotes
        rowVersion
        address {
          address1
          address2
          city
          country
          state
          postalCode
          lat
          long
          isMappable
        }
        primaryContactId
        contactLinks {
          locationContactLinkId
          contact {
            id
            firstName
            lastName
            phone
            email
            active
            rowVersion
          }
        }
      }
    }
  }
`;

export const postalCodeById = gql`
  query location($id: ID!) {
    location {
      byId(id: $id) {
        address {
          postalCode
        }
      }
    }
  }
`;

export const pagedLocationsQuery = gql`
  query location(
    $orgId: ID!
    $limit: Int!
    $offset: Int!
    $includeExpired: Boolean
  ) {
    location {
      paged(
        orgId: $orgId
        limit: $limit
        offset: $offset
        includeExpired: $includeExpired
      ) {
        results {
          name
          id
          orgId
          externalId
          address {
            address1
            address2
            city
            state
            country
            postalCode
          }
          rowVersion
          timeZoneId
          pickupNotes
          deliveryNotes
          active
        }
        hasMoreData
        limit
        offset
        totalCount
      }
    }
  }
`;
